export var EventAction;
(function (EventAction) {
    EventAction["SESSION_EXPIRED"] = "expired";
    EventAction["SESSION_EXTENDED_AUTOMATICALLY"] = "extended-automatically";
    EventAction["SESSION_EXTENDED_MANUALLY"] = "extended-manually";
    EventAction["SESSION_COUNTDOWN_SHOWN"] = "shown";
})(EventAction || (EventAction = {}));
//# sourceMappingURL=events.js.map